/**
 * carousel.js
 * 
 * Initialise all carousels on the page with the glide carousel library.
 */

function init_carousel_tiles($, window, document) {


  const carousels = $('.tms-carousel-tiles');

  if (carousels.length > 0) {

    $.each(carousels, function() {

      // For some reason the > converts the following quote to a smart quote...
      $(this).find('.glide__arrow--left').attr('data-glide-dir', "|<");
      $(this).find('.glide__arrow--right').attr('data-glide-dir', "|>");
      
      const glide = new Glide( this, {
        type: "slider",
        gap: 24,
        rewind: true,
        animationDuration: 400,
        animationTimingFunc: "".concat("cubic-bezier(0.35, 0.00, 0.36, 1.00)", " ").concat(0, "ms"),
        perView: 3,
        perSwipe: "|",

        breakpoints: {
            768: {
                perView: 1,
                gap: 20,
                peek: {
                    after: 0,
                    before: 0
                }
            },
            992: {
                perView: 2,
                peek: {
                    after: 0,
                    before: 0
                }
            }
        }
      } );

      // Setup the bullets for responsive counts

      let slideCount = 1;
      const windowWidth = window.innerWidth;
      if (windowWidth > 768) { slideCount = 2; } 
      if (windowWidth > 992) { slideCount = 3; } 

      if (slideCount === 3) {
        $(this).find('.glide__bullet:nth-child(3n+2), .glide__bullet:nth-child(3n+3)').remove();
      } else 
      if (slideCount === 2) {
        $(this).find('.glide__bullet:nth-child(2n)').remove();
      }

      $(this).find('.glide__bullets').show();

      const this_carousel = this;
      glide.on('move.after', () => {
        
        const currentView = Math.floor(glide.index / slideCount); // Calculate current view index
        const bullets = $(this_carousel).find('.glide__bullet');
        $.each(bullets, function(index) {

          $(this).toggleClass('active', index === currentView);

          $(this).attr('aria-selected', false);
          if (index === currentView) {
            $(this).attr('aria-selected', true);
          }

        });
      });

      glide.mount()
    });
    
  } 


}



document.addEventListener('DOMContentLoaded', () => {
  init_carousel_tiles(jQuery, window, document);
});